
  const reduce=matchMedia('(prefers-reduced-motion:reduce)').matches;
  const nav=document.getElementById('nav'),prog=document.getElementById('prog'),bloom=document.querySelector('.bloom'),
        intro=document.getElementById('intro'),hsec=document.querySelector('.hscroll'),aura=document.getElementById('aura'),
        split=document.querySelector('.split'),dTop=document.querySelector('.door.top'),dBot=document.querySelector('.door.bot');

  /* intro: play the load-in film, reveal site when it resolves to the logo */
  const vid=document.querySelector('.introvid');
  let revealed=false;
  function reveal(){ if(revealed)return; revealed=true; document.body.classList.add('reveal-on'); intro.classList.add('done'); }
  if(reduce){ reveal(); }
  else{
    if(vid){
      const p=vid.play&&vid.play(); if(p&&p.catch)p.catch(()=>{});
      vid.addEventListener('loadeddata',()=>vid.classList.add('on'));
      vid.addEventListener('ended',reveal);
      vid.addEventListener('error',()=>setTimeout(reveal,3400));
    }
    setTimeout(reveal,4600);
  }
  document.getElementById('skip').addEventListener('click',reveal);

  /* one batched rAF loop for all scroll work */
  let sy=0,lastSy=0,vel=0,ticking=false;
  function measure(){
    nav.classList.toggle('scrolled',sy>20);
    prog.style.width=(sy/(document.body.scrollHeight-innerHeight)*100)+'%';
    if(aura) aura.style.transform=`translateY(${sy*.1}px)`;
    if(hsec && getComputedStyle(hsec.querySelector('.hsticky')).position==='sticky'){
      const top=hsec.offsetTop,h=hsec.offsetHeight,track=hsec.querySelector('.htrack');
      const p=Math.min(Math.max((sy-top)/(h-innerHeight),0),1);
      const maxX=Math.max(track.scrollWidth-innerWidth+80,0);
      const skew=Math.max(-4,Math.min(4,vel*.16));
      track.style.transform=`translateX(${-p*maxX}px) skewX(${skew}deg)`;
    }
    if(split && dTop && getComputedStyle(split.querySelector('.split-sticky')).position==='sticky'){
      const top=split.offsetTop,h=split.offsetHeight;
      const p=Math.min(Math.max((sy-top)/(h-innerHeight),0),1);
      const e=p<.5?2*p*p:1-Math.pow(-2*p+2,2)/2;            // easeInOutQuad
      dTop.style.transform=`translateY(${-e*100}%)`;
      dBot.style.transform=`translateY(${e*100}%)`;
    }
    ticking=false;
  }
  function onScroll(){ sy=scrollY; vel=sy-lastSy; lastSy=sy; if(!ticking){ticking=true;requestAnimationFrame(measure);} }
  addEventListener('scroll',onScroll,{passive:true}); addEventListener('resize',onScroll);

  const io=new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('in','show');io.unobserve(e.target)}}),{threshold:.16});
  document.querySelectorAll('.rv,.rvL,.rvR').forEach((el,i)=>{el.style.transitionDelay=(i%4*70)+'ms';io.observe(el)});
  document.querySelectorAll('.reveal-lines').forEach(el=>io.observe(el));

  const cu=new IntersectionObserver(es=>es.forEach(e=>{if(!e.isIntersecting)return;
    document.querySelectorAll('.num').forEach(n=>{const to=+n.dataset.to,suf=n.dataset.suf||'',tgt=n.querySelector('i')||n;let s=null;const d=1500;
      const step=t=>{s=s||t;const p=Math.min((t-s)/d,1);tgt.textContent=Math.round((1-Math.pow(1-p,3))*to)+suf;if(p<1)requestAnimationFrame(step)};requestAnimationFrame(step)});cu.disconnect();}),{threshold:.4});
  cu.observe(document.getElementById('numbers'));

  const steps=[...document.querySelectorAll('.svc-step')],idxEl=document.getElementById('svcIndex'),titEl=document.getElementById('svcTitle'),descEl=document.getElementById('svcDesc'),dots=document.querySelectorAll('.svc-dots span');
  const so=new IntersectionObserver(es=>es.forEach(e=>{if(!e.isIntersecting)return;const i=+e.target.dataset.i;
    steps.forEach(s=>s.classList.toggle('active',s===e.target));
    idxEl.textContent='0'+(i+1); titEl.textContent=e.target.dataset.title; descEl.innerHTML=e.target.dataset.desc;
    dots.forEach((d,di)=>d.classList.toggle('on',di===i));
  }),{rootMargin:'-45% 0px -45% 0px'});
  steps.forEach(s=>so.observe(s));

  document.querySelectorAll('.btn').forEach(b=>{b.addEventListener('mousemove',e=>{const r=b.getBoundingClientRect();b.style.transform=`translate(${(e.clientX-r.left-r.width/2)*.22}px,${(e.clientY-r.top-r.height/2)*.35}px) scale(1.04)`});b.addEventListener('mouseleave',()=>b.style.transform='')});

  if(matchMedia('(pointer:fine)').matches && !reduce){
    const c=document.querySelector('.cur'),d=document.querySelector('.cur-d');let cx=0,cy=0,tx=0,ty=0;
    addEventListener('mousemove',e=>{tx=e.clientX;ty=e.clientY;d.style.left=tx+'px';d.style.top=ty+'px'});
    (function loop(){cx+=(tx-cx)*.18;cy+=(ty-cy)*.18;c.style.left=cx+'px';c.style.top=cy+'px';requestAnimationFrame(loop)})();
    document.querySelectorAll('a,.btn,.hpanel,.svc-step,.offer,.llogo,input,textarea').forEach(el=>{el.addEventListener('mouseenter',()=>c.classList.add('grow'));el.addEventListener('mouseleave',()=>c.classList.remove('grow'))});
  }

  const form=document.getElementById('cform'),ferr=document.getElementById('ferr');
  form.addEventListener('submit',e=>{e.preventDefault();
    const name=form.name.value.trim(),email=form.email.value.trim(),msg=form.message.value.trim();
    if(!name||!email||!msg){ferr.textContent='Add your name, email, and a quick note.';return;}
    if(!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)){ferr.textContent='That email looks off. Check it?';form.email.focus();return;}
    ferr.textContent='';
    const body=encodeURIComponent(`Name: ${name}\nEmail: ${email}\nCompany: ${form.company.value.trim()}\n\n${msg}`);
    location.href=`mailto:slater@brandedaxis.com?subject=${encodeURIComponent('New inquiry from '+name)}&body=${body}`;
  });

  /* work panels: optional client hero video, else live screenshot */
  (function(){
    const vio=new IntersectionObserver(es=>es.forEach(e=>{const v=e.target;if(e.isIntersecting){const p=v.play&&v.play();if(p&&p.catch)p.catch(()=>{})}else{v.pause&&v.pause()}}),{threshold:.4});
    document.querySelectorAll('.bshot').forEach((sh,i)=>{const img=sh.querySelector('img');if(!img)return;
      const v=document.createElement('video');v.className='bvid';v.muted=true;v.loop=true;v.playsInline=true;v.preload='metadata';v.setAttribute('playsinline','');
      v.src='work-'+(i+1)+'.mp4';
      v.addEventListener('loadeddata',()=>{v.classList.add('ready');vio.observe(v)});
      v.addEventListener('error',()=>{v.remove()});
      sh.appendChild(v);});
  })();
  /* interactive hero field: cobalt dot grid that scatters + lights under the cursor */
  (function(){
    const cv=document.getElementById('herofx'); if(!cv) return;
    const reduce=matchMedia('(prefers-reduced-motion:reduce)').matches;
    const ctx=cv.getContext('2d'); let pts=[],W=0,H=0,dpr=Math.min(devicePixelRatio||1,2);
    let mx=-9999,my=-9999,raf=0,vis=true;
    const GAP=44,R=170;
    function build(){
      const r=cv.parentElement.getBoundingClientRect();W=r.width;H=r.height;
      cv.width=W*dpr;cv.height=H*dpr;cv.style.width=W+'px';cv.style.height=H+'px';
      ctx.setTransform(dpr,0,0,dpr,0,0);pts=[];
      for(let y=GAP/2;y<H;y+=GAP)for(let x=GAP/2;x<W;x+=GAP)pts.push({x,y,bx:x,by:y,i:x*0.01,j:y*0.01});
    }
    function frame(t){
      ctx.clearRect(0,0,W,H);
      if(mx>-5000){const g=ctx.createRadialGradient(mx,my,0,mx,my,R*1.4);g.addColorStop(0,'rgba(84,104,255,.10)');g.addColorStop(1,'rgba(84,104,255,0)');ctx.fillStyle=g;ctx.fillRect(0,0,W,H);}
      for(let k=0;k<pts.length;k++){const p=pts[k];
        const ox=Math.sin(t*0.0006+p.i)*2.4, oy=Math.cos(t*0.0005+p.j)*2.4;
        let px=p.bx+ox, py=p.by+oy;
        const dx=px-mx, dy=py-my, dist=Math.hypot(dx,dy);
        let infl=dist<R?1-dist/R:0; infl*=infl;
        if(infl>0){const a=Math.atan2(dy,dx),push=infl*16;px+=Math.cos(a)*push;py+=Math.sin(a)*push;}
        const size=1+infl*2.2, al=0.05+infl*0.55;
        const rC=Math.round(236+(84-236)*infl),gC=Math.round(233+(104-233)*infl),bC=Math.round(225+(255-225)*infl);
        ctx.beginPath();ctx.fillStyle='rgba('+rC+','+gC+','+bC+','+al+')';ctx.arc(px,py,size,0,6.283);ctx.fill();
      }
      raf=requestAnimationFrame(frame);
    }
    build();
    if(reduce){ // static field, no loop
      for(const p of pts){ctx.beginPath();ctx.fillStyle='rgba(236,233,225,.06)';ctx.arc(p.bx,p.by,1,0,6.283);ctx.fill();} return;
    }
    addEventListener('mousemove',e=>{const r=cv.getBoundingClientRect();mx=e.clientX-r.left;my=e.clientY-r.top;},{passive:true});
    addEventListener('mouseout',()=>{mx=-9999;my=-9999;});
    let rt;addEventListener('resize',()=>{clearTimeout(rt);rt=setTimeout(build,160)});
    const io=new IntersectionObserver(es=>{vis=es[0].isIntersecting; if(vis&&!raf){raf=requestAnimationFrame(frame);} else if(!vis&&raf){cancelAnimationFrame(raf);raf=0;}});
    io.observe(cv);
    raf=requestAnimationFrame(frame);
  })();

